import React from "react";
import Header from "./components/header/Header";
import Nav from "./components/nav/Nav";
import About from "./components/about/About";
import Experience from "./components/experience/Experience";
// import Art from './components/art/Art';
import Portfolio from "./components/portfolio/Portfolio";
import Testimonials from "./components/testimonials/Testimonials";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
import Guide from "./components/big_tech_guide/guide";

const App = () => {
  return (
    <>
      <Header />
      <Nav />
      <About />
      <Experience />
      <Testimonials />
      <Portfolio />
      {/* <Art /> */}
      <Guide />
      <Contact />
      <Footer />
    </>
  );
};

export default App;
